<template>
    <p :title="title">{{ timeFromNow }}</p>
</template>

<script>
import moment from 'moment-timezone'

export default {
    name: 'TimeAgo',
    props: {
        fromDatetime: {
            type: String,
            required: true,
        },
        nowDatetime: {
            type: String,
            default: null,
        },
        shorter: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            interval: null,
        }
    },
    computed: {
        datetime() {
            return moment.min(
                moment(this.fromDatetime),
                this.nowDatetime ? moment(this.nowDatetime) : moment()
            )
        },
        title() {
            return this.datetime.format('DD.MM.YYYY HH:mm')
        },
        timeFromNow() {
            if (this.shorter && moment().diff(this.datetime, 'minutes') < 1) {
                return this.$t('now')
            }
            return this.datetime.fromNow()
        },
    },
    created() {
        moment.locale(this.$i18n.locale)

        if (this.nowDatetime === null) {
            this.interval = setInterval(() => this.$forceUpdate(), 30000)
        }
    },
    beforeDestroy() {
        clearInterval(this.interval)
    },
}
</script>

<i18n>
{
    "en": {
        "now": "now"
    },
    "de": {
        "now": "jetzt"
    },
    "fr": {
        "now": "maintenant"
    },
    "it": {
        "now": "ora"
    }
}
</i18n>
